export default __webpack_public_path__ + "static/media/trybe.424a2103.png";